import React from 'react';
import { ScrollText, ShieldCheck } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { TERMS_SECTIONS, TERMS_INTRO, CONTAINER_TERMS_SECTIONS, CONTAINER_TERMS_INTRO } from '../data/termsData';

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-gray-50 pt-40 pb-20" data-testid="terms-page">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-burgundy mb-4">
            <ScrollText size={26} className="text-gold" />
          </div>
          <p className="text-gold text-xs font-semibold uppercase tracking-[0.25em] mb-2">NJK Logistics Pte Ltd</p>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">Terms &amp; Conditions</h1>
          <p className="text-sm text-gray-500 mt-3 max-w-xl mx-auto">
            For Trucking, Container Haulage and Logistics Services
          </p>
        </div>

        <div className="bg-white border rounded-xl p-5 mb-8 text-sm text-gray-600 leading-relaxed" data-testid="terms-intro">
          {TERMS_INTRO}
        </div>

        <Accordion type="multiple" className="space-y-3" data-testid="terms-accordion">
          {TERMS_SECTIONS.map((s) => (
            <AccordionItem key={s.id} value={s.id} className="bg-white border rounded-xl px-5 shadow-sm">
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-burgundy hover:no-underline" data-testid={`terms-section-${s.id}`}>
                {s.title}
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-2.5 text-sm text-gray-600 leading-relaxed pb-2">
                  {s.clauses.map((c, i) => (
                    <li key={i}>{c}</li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-14 mb-8" data-testid="container-terms-heading">
          <p className="text-gold text-xs font-semibold uppercase tracking-[0.25em] mb-2">Container Trucking</p>
          <h2 className="text-lg font-bold text-gray-900">Container Trucking Services — Terms &amp; Conditions</h2>
        </div>

        <div className="bg-white border rounded-xl p-5 mb-8 text-sm text-gray-600 leading-relaxed" data-testid="container-terms-intro">
          {CONTAINER_TERMS_INTRO}
        </div>

        <Accordion type="multiple" className="space-y-3" data-testid="container-terms-accordion">
          {CONTAINER_TERMS_SECTIONS.map((s) => (
            <AccordionItem key={s.id} value={s.id} className="bg-white border rounded-xl px-5 shadow-sm">
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-burgundy hover:no-underline" data-testid={`terms-section-${s.id}`}>
                {s.title}
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-2.5 text-sm text-gray-600 leading-relaxed pb-2">
                  {s.clauses.map((c, i) => (
                    <li key={i}>{c}</li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="flex items-center justify-center gap-2 mt-12 text-sm text-gray-500">
          <ShieldCheck size={16} className="text-gold" />
          <span className="font-semibold text-burgundy">NJK LOGISTICS SERVICES</span>
          <span>— Professional Service • Safe Operations • Reliable Delivery</span>
        </div>
      </div>
    </div>
  );
}
